import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import LandingPage from './pages/LandingPage'
import CustomerPortal from './pages/CustomerPortal'
import CustomerProfilePage from './pages/CustomerProfilePage'
import BrokerPortal from './pages/BrokerPortal'
import BrokerProfilePage from './pages/BrokerProfilePage'
import BrokerMarketplace from './pages/BrokerMarketplace'
import BrokerDetailPage from './pages/BrokerDetailPage'
import BrokerSelectCustomerPage from './pages/BrokerSelectCustomerPage'
import AdminPortal from './pages/AdminPortal'
import DataEntryPortal from './pages/DataEntryPortal'
import AuthCallbackPage from './pages/AuthCallbackPage'
import LoginPage from './pages/LoginPage'
import DocumentVaultPage from './pages/DocumentVaultPage'
import FinancialProfilePage from './pages/FinancialProfilePage'
import MessagesPage from './pages/MessagesPage'
import TermsAndConditions from './pages/legal/TermsAndConditions'
import PrivacyPolicy from './pages/legal/PrivacyPolicy'
import Disclaimer from './pages/legal/Disclaimer'
import FinancialServicesGuide from './pages/legal/FinancialServicesGuide'
import DataDeletion from './pages/legal/DataDeletion'

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/customer" element={<CustomerPortal />} />
        <Route
          path="/customer/profile"
          element={
            <ProtectedRoute requiredRole="customer">
              <CustomerProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer/documents"
          element={
            <ProtectedRoute requiredRole="customer">
              <DocumentVaultPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer/financial-profile"
          element={
            <ProtectedRoute requiredRole="customer">
              <FinancialProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/messages"
          element={
            <ProtectedRoute requiredRole={['customer', 'broker']}>
              <MessagesPage />
            </ProtectedRoute>
          }
        />
        <Route path="/broker" element={<BrokerPortal />} />
        <Route path="/broker/profile" element={<BrokerProfilePage />} />
        <Route path="/broker/select-customer" element={<BrokerSelectCustomerPage />} />
        <Route path="/brokers" element={<BrokerMarketplace />} />
        <Route path="/brokers/:id" element={<BrokerDetailPage />} />
        <Route path="/admin" element={<AdminPortal />} />
        <Route
          path="/dataentry"
          element={
            <ProtectedRoute requiredRole={['admin', 'data_operator']}>
              <DataEntryPortal />
            </ProtectedRoute>
          }
        />
        <Route path="/legal/terms" element={<TermsAndConditions />} />
        <Route path="/legal/privacy" element={<PrivacyPolicy />} />
        <Route path="/legal/disclaimer" element={<Disclaimer />} />
        <Route path="/legal/fsg" element={<FinancialServicesGuide />} />
        {/* Short URLs for Facebook OAuth requirements */}
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/data-deletion" element={<DataDeletion />} />
      </Routes>
    </AuthProvider>
  )
}

export default App
